import { render, staticRenderFns } from "./job-in-focus-box.vue?vue&type=template&id=440e2b28"
import script from "./job-in-focus-box.vue?vue&type=script&lang=js"
export * from "./job-in-focus-box.vue?vue&type=script&lang=js"
import style0 from "./job-in-focus-box.vue?vue&type=style&index=0&id=440e2b28&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports